export default __webpack_public_path__ + "static/Nakorn leasing_logo-59463dca8f5b4fcdf9213ea9247c8de2.png";